import React from 'react'

const Manual_funciones_configuracion_clau_admin = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Funciones de "Configuración" dentro de Clau Admin
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende sobre las funciones disponibles en el módulo de configuración dentro de Clau Admin.
        </p>
        <iframe
          src="https://scribehow.com/embed/Funciones_de_Configuracion_dentro_de_Clau_Admin__CFHgzhD1S4OQCR2Kt2snVA?as=scrollable"
          className="scribe-iframe-general-62"
          width="100%"
          height="6500"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_funciones_configuracion_clau_admin
